<ion-header class="ion-no-border">
    <web-header
        [title]="title"
        [icon]="icon"
        [iconColor]="iconColor"
        [loader]="loader"
        [displayIcon]="displayIcon"
        [background]="background"
        (action)="triggerAction()"
        [disabled]="disabled"
    ></web-header>
</ion-header>
<ng-content></ng-content>
